import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-non-admin',
  templateUrl: './non-admin.component.html',
  styleUrls: ['./non-admin.component.scss']
})
export class NonAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
